/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { LiveManagementGetTokenResponse } from './LiveManagementGetTokenResponse';

export type LiveManagementGetTokenResponseApiRespoonse = {
    data?: LiveManagementGetTokenResponse;
    status?: LiveManagementGetTokenResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace LiveManagementGetTokenResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

